var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5897 10.4916C15.1513 9.9299 16.062 9.9299 16.6236 10.4916L25.253 19.1209C25.8146 19.6826 25.8146 20.5932 25.253 21.1549C24.6913 21.7165 23.7807 21.7165 23.219 21.1549L15.6066 13.5425L7.99427 21.1549C7.4326 21.7165 6.52197 21.7165 5.96031 21.1549C5.39865 20.5932 5.39865 19.6826 5.96031 19.1209L14.5897 10.4916Z",
    fill: "#8493B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up_arrow.9e2784f5c68ef152e0528cc306677b87.svg";
export { ForwardRef as ReactComponent };